import Alpine from "alpinejs";

document.addEventListener('alpine:init', () => {
    Alpine.data('initFaqRating', (questionId:any) => {
        return {
            results: [],
            questionId: questionId,
            init() {
                console.log('rating works')
            },
            faqRating(rate:any) {
                const apiCall = window.location.origin + '/api/faq/' + questionId + '/mark/'
                const formData = new FormData();
                formData.append("mark", rate);
                const request = new XMLHttpRequest();
                request.open("POST", apiCall);
                request.send(formData);
            }
        }
    })
})
